export enum FormlyFieldType {
  AsyncSelect = 'asyncSelect',
  AutoRepeat = 'auto-repeat',
  Button = 'button',
  Checkbox = 'checkbox',
  GenericSelect = 'generic-select',
  Custom = 'custom',
  DateRange = 'date-range',
  ImageUpload = 'image-upload',
  AssetUpload = 'asset-upload',
  Input = 'input',
  ColorPicker = 'color-picker',
  Repeat = 'repeat',
  Select = 'select',
  StyledRadio = 'styled-radio',
  Radio = 'radio',
  Textarea = 'textarea',
  Virtual = 'virtual',
  Text = 'text',
  Expansion = 'expansion',
  Selection = 'selection',
  Date = 'date',
}

export enum FormlyWrapper {
  FormField = 'form-field',
  Grid = 'grid',
  InlineLabel = 'inline-label',
  LabelTooltip = 'label-tooltip',
  Panel = 'panel',
  Expansion = 'expansion',
}

export enum FormlyValidator {
  NoSpacesAllowed = 'no-spaces-allowed',
  Alphanumeric = 'alpha-numeric',
  AlphanumericAndSlash = 'alpha-numeric-and-slash',
  AlphanumericAndDash = 'alpha-numeric-and-dash',
}

export type SelectOption<T = string> = {
  label: string;
  value: T;
};
